// src/services/dispositivoService.js
import api from "./Api"; // respeta la A mayúscula

// ----------- DISPOSITIVOS -------------
export const obtenerMisDispositivos = async () => {
  try {
    const { data } = await api.cachedGet("/Dispositivos/mis-dispositivos");
    return data;
  } catch (error) {
    console.error("❌ Error al obtener los dispositivos:", error);
    throw new Error("No se pudieron obtener los dispositivos. Intenta nuevamente.");
  }
};

export const obtenerDispositivosPorEstanque = async (estanqueId) => {
  const { data } = await api.cachedGet("/Dispositivos/mis-dispositivos");
  return (data || []).filter((dispositivo) => dispositivo.estanqueId === Number(estanqueId));
};

export const rotarClaveDispositivo = async (id, password) => {
  const { data } = await api.post(`/Dispositivos/${id}/api-key/rotate`, { password });
  return data;
};

export const revelarClaveDispositivo = async (id, password) => {
  const { data } = await api.post(`/Dispositivos/${id}/api-key/reveal`, { password });
  return data;
};

export const obtenerDetallesDispositivo = async (id) =>
  (await api.get(`/Dispositivos/${id}/detalles`)).data;

export const iniciarReemplazoDispositivo = async (id) =>
  (await api.post(`/Dispositivos/${id}/reemplazo/iniciar`)).data;

export const cancelarReemplazoDispositivo = async (id) =>
  (await api.delete(`/Dispositivos/${id}/reemplazo`)).data;

// ----------- SENSORES -------------
export const crearSensor = async (sensorData) => {
  const { data } = await api.post("/Sensores/crear", sensorData);
  return data;
};

export const actualizarSensor = async (id, sensorData) => {
  const { data } = await api.put(`/Sensores/actualizar/${id}`, sensorData);
  return data;
};

export const obtenerSensoresActivos = async (estanqueId) => {
  const { data } = await api.cachedGet("/Sensores/todos");
  return (data || []).filter((s) => s.estanqueId === Number(estanqueId) && s.estaActivo);
};

export const obtenerTodosLosSensores = async (estanqueId) => {
  const { data } = await api.cachedGet("/Sensores/todos");
  return (data || []).filter((s) => s.estanqueId === Number(estanqueId));
};

export const obtenerTiposParametro = async () => {
  const { data } = await api.cachedGet("/Sensores/tipos");
  return data;
};

export const cambiarEstadoActivoSensor = async (id) => {
  const { data } = await api.put(`/Sensores/toggle-activo/${id}`, {});
  return data;
};

// ----------- EFECTORES -------------
export const crearEfector = async (efectorData) => {
  const { data } = await api.post("/Efectores/crear", efectorData);
  return data;
};

export const actualizarEfector = async (id, efectorData) => {
  const { data } = await api.put(`/Efectores/actualizar/${id}`, efectorData);
  return data;
};

export const obtenerEfectoresPorEstanque = async (estanqueId) => {
  const { data } = await api.cachedGet("/Efectores/mis-efectores");
  return (data || []).filter((efector) => efector.estanqueId === Number(estanqueId));
};

export const obtenerTiposEfector = async () => {
  const { data } = await api.cachedGet("/Efectores/tipos");
  return data;
};

// ✅ Export default con nombre (evita "import/no-anonymous-default-export")
const dispositivoService = {
  obtenerMisDispositivos,
  obtenerDispositivosPorEstanque,
  rotarClaveDispositivo,
  revelarClaveDispositivo,
  obtenerDetallesDispositivo,
  iniciarReemplazoDispositivo,
  cancelarReemplazoDispositivo,
  crearSensor,
  actualizarSensor,
  obtenerSensoresActivos,
  obtenerTodosLosSensores,
  obtenerTiposParametro,
  cambiarEstadoActivoSensor,
  crearEfector,
  actualizarEfector,
  obtenerEfectoresPorEstanque,
  obtenerTiposEfector,
};

export default dispositivoService;
